<div class="card">
  <div class="card-header">
    <div class="row align-items-center flex-nowrap">
      <div class="col">
        <div class="row g-2 align-items-center flex-nowrap">
          <div class="col-auto">
            <div class="card-icon">
              <i class="bx bxs-message"></i>
            </div>
          </div>
          <div class="col">
            <h4 class="m-0">Messages</h4>
          </div>
        </div>
      </div>
      <div class="col text-end lh-1">
        <a [routerLink]="['messages']" class="text-icon float-end">
          See all messages
          <i class="bx bx-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="card-body" *ngIf="inbox">
    <div class="card card-light" *ngFor="let keyValue of inbox | keyvalue | slice: 0 : 2">
      <ng-container *ngIf="keyValue.value as _message">
        <a class="card-body" href="javascript: void(0);" (click)="onConversation(keyValue)">
          <div class="row g-2">
            <div class="col-auto" [style.width]="'60px'">
              <img
                appAvatar="{{
                  _message.receiverUid === user?.id ? _message.senderUid : _message.receiverUid
                }}"
                src="https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable"
                alt="User Avatar"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col">
              <h5 class="text-primary fw-bolder m-0">
                {{ _message.name }}
              </h5>
              <p class="col paragraph-truncate lines-2 m-0">
                {{ _message.message }}
              </p>
            </div>
          </div>
        </a>
      </ng-container>
    </div>
  </div>
</div>
